import Constants from '@/constants'

export const redirect = {
  data() {
    return {
      hasRedirectedToMerchant: false,
    }
  },
  computed: {
    hasRedirected() {
      return this.hasRedirectedToMerchant
    },
  },
  methods: {
    async callGetMerchantSettings() {
      try {
        await this.loadSettings({
          transactionId: this.transactionId,
          merchantCode: this.transaction.merchantCode,
          retries: Constants.maxRetryOnError,
        })
      } catch (error) {
        if (this.transactionId) {
          await this.$logError({
            transactionId: this.transactionId,
            message: 'Redirection error - load settings',
            stackTrace: error,
          })
        }
      }
    },
    async callOpenMerchant() {
      try {
        // If we have already redirected then, dont try redirect again
        if (this.hasRedirectedToMerchant) {
          return
        }
        this.hasRedirectedToMerchant = true

        this.isLoading = true
        await this.callGetTransaction()
        await this.callGetMerchantSettings()

        if (!this.canOpenMerchant) {
          return
        }

        const data = {
          status: this.transaction.status,
          merchantCode: this.transaction.merchantCode || '',
          currency: this.transaction.currency || '',
          country: this.transaction.country || '',
          referenceMerchant: this.transaction.sellerReference || '',
          amount: this.transaction.amount || '',
          bank: this.transaction.acquirerName || '',
          date: this.transaction.date || '',
          receipt: this.transaction.receiptNumber || '',
          transactionId: this.transaction.id || '',
          custom01: this.transaction.custom01 || '',
          custom02: this.transaction.custom02 || '',
          custom03: this.transaction.custom03 || '',
          custom04: this.transaction.custom04 || '',
          custom05: this.transaction.custom05 || '',
          consistent: this.transaction.returnConsistent || '',
        }

        this.$logInfo({
          transactionId: this.transaction.id,
          system: process.env.VUE_APP_ENVIRONMENT,
          message: JSON.stringify(data),
        })

        // Set the form values and submit the form
        const redirectForm = this.$refs.redirectForm
        redirectForm.action = this.merchantReturnURL
        redirectForm.elements.SID_STATUS.value = data.status
        redirectForm.elements.SID_MERCHANT.value = data.merchantCode
        redirectForm.elements.SID_COUNTRY.value = data.country
        redirectForm.elements.SID_CURRENCY.value = data.currency
        redirectForm.elements.SID_REFERENCE.value = data.referenceMerchant
        redirectForm.elements.SID_AMOUNT.value = data.amount
        redirectForm.elements.SID_BANK.value = data.bank
        redirectForm.elements.SID_DATE.value = data.date
        redirectForm.elements.SID_RECEIPTNO.value = data.receipt
        redirectForm.elements.SID_TNXID.value = data.transactionId
        redirectForm.elements.SID_CUSTOM_01.value = data.custom01
        redirectForm.elements.SID_CUSTOM_02.value = data.custom02
        redirectForm.elements.SID_CUSTOM_03.value = data.custom03
        redirectForm.elements.SID_CUSTOM_04.value = data.custom04
        redirectForm.elements.SID_CUSTOM_05.value = data.custom05
        redirectForm.elements.SID_CONSISTENT.value = data.consistent
        redirectForm.submit()
      } catch (e) {
        this.isLoading = false
      }
    },
  },
}
